export default __webpack_public_path__ + "static/media/inventory.9562075a.svg";